var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-select", {
    attrs: {
      id: "searchStatus",
      "menu-props": "auto",
      items: _vm.statusList,
      value: _vm.value,
      label: "Pesquise pelo status",
      "item-text": "name",
      "item-value": "value"
    },
    on: {
      change: function($event) {
        return _vm.$emit("input", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }